import { render, staticRenderFns } from "./GoodsClaimApproval.vue?vue&type=template&id=25f4a4d4&scoped=true"
import script from "./GoodsClaimApproval.vue?vue&type=script&lang=js"
export * from "./GoodsClaimApproval.vue?vue&type=script&lang=js"
import style0 from "./GoodsClaimApproval.vue?vue&type=style&index=0&id=25f4a4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4a4d4",
  null
  
)

export default component.exports